import React from 'react';
import { isPreview } from 'common/utils/is-preview';

export function useDFP(params) {
	const { containerId, slotPath, slotSize, targeting, closable } = params;
	const { location } = window;
	const isPreviewMode = isPreview(location.search);

	const [isClosed, setIsClosed] = React.useState(process.env.ENV === 'local' || isPreviewMode);
	const [isRendered, setIsRendered] = React.useState(false);

	const minWidth = Array.isArray(slotSize[0])
		? slotSize.reduce((acc, [w]) => (w < acc ? w : acc), slotSize[0][0])
		: slotSize[0];

	const minHeight = Array.isArray(slotSize[0])
		? slotSize.reduce((acc, [, h]) => (h < acc ? h : acc), slotSize[0][1])
		: slotSize[1];

	React.useEffect(() => {
		if (isClosed || !containerId || !slotPath) return;

		const controller = new AbortController();
		const container = document.querySelector(`#${containerId}`);
		const { googletag } = window;
		const topWindow = window.top;
		let slot = null;

		if (googletag && container) {
			if (closable) {
				topWindow.DFP ??= {};
				topWindow.DFP.onMaavaronClose = () => {
					setIsClosed(true);
				};
			}

			window.addEventListener(
				'DFPDecision',
				e => {
					const [, , closed] = e.detail;
					setIsClosed(closed);
				},
				{ signal: controller.signal }
			);

			googletag.cmd.push(() => {
				slot = googletag.defineSlot(slotPath, slotSize, containerId).addService(googletag.pubads());

				googletag.pubads().enableSingleRequest();

				if (targeting) {
					googletag.pubads().setTargeting(...targeting);
				}

				googletag.pubads().addEventListener('slotRenderEnded', e => {
					if (e.slot.getSlotElementId() === containerId) {
						setIsRendered(!e.isEmpty);
					}
				});

				googletag.enableServices();
			});

			googletag.cmd.push(() => {
				googletag.display(containerId);
			});
		}

		// eslint-disable-next-line consistent-return
		return () => {
			// eslint-disable-next-line no-unused-expressions
			googletag?.destroySlots(slot ? [slot] : []);
			controller.abort();
		};
	}, [isClosed, containerId, slotPath, slotSize]);

	return {
		isClosed,
		isRendered,
		minWidth,
		minHeight,
	};
}
